(function () {
  const MIN = 107;
  const MAX = 283;

  function getISOWeekStamp(date) {
    const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    const day = d.getUTCDay() || 7;
    d.setUTCDate(d.getUTCDate() + 4 - day);
    const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
    const weekNo = Math.ceil((((d - yearStart) / 86400000) + 1) / 7);
    return `${d.getUTCFullYear()}-W${String(weekNo).padStart(2, "0")}`;
  }

  function addDays(date, days) {
    const d = new Date(date);
    d.setDate(d.getDate() + days);
    return d;
  }

  // Deterministic hash (FNV-1a)
  function fnv1a(str) {
    let h = 0x811c9dc5;
    for (let i = 0; i < str.length; i++) {
      h ^= str.charCodeAt(i);
      h = Math.imul(h, 0x01000193);
    }
    return h >>> 0;
  }

  function isRoundNumber(num) {
    return num % 10 === 0;
  }

  const lastWeekStamp = getISOWeekStamp(addDays(new Date(), -7));

  document.querySelectorAll('[data-product-id]').forEach((row) => {
    const productId = row.getAttribute("data-product-id");
    if (!productId) return;

    const seed = `${productId}_${lastWeekStamp}`;
    let hash = fnv1a(seed);

    let count;
    let attempts = 0;

    do {
      count = MIN + (hash % (MAX - MIN + 1));
      hash = fnv1a(String(hash)); // rehash to escape round numbers
      attempts++;
    } while (isRoundNumber(count) && attempts < 5);

    // Final safety nudge (extremely unlikely fallback)
    if (isRoundNumber(count)) {
      count += 3;
      if (count > MAX) count -= 7;
    }

    const el = row.querySelector(".weekly-orders");
    if (el) el.innerText = String(count);
  });
})();
